import './officeShipPageComponent.css'

import { useEffect, useState } from 'react'
import { Button, Col, Form, Modal, OverlayTrigger, Row, Spinner, Table, Tooltip } from 'react-bootstrap'
import InfiniteScroll from 'react-infinite-scroller'
import { useSelector } from 'react-redux'

import { getFullUrl } from '../../../helpers/files'
import { getPrice } from '../../../helpers/getPrice'
import { sortPackagesDataByDatePaid } from '../../../helpers/sortByupdateDate'
import flammableIcon from '../../../imgs/flammable.png'
import scrollUpIcon from '../../../imgs/up-arrow.png'
import { getAllPackages, getPackagesByIndex, updatePackage } from '../../../services/packages'
import { packageShipping } from '../../../services/shipping'
import OfficeCountryNavBar from '../OfficeCountryNavBar/OfficeCountryNavBar'

export default function OfficeShipPageComponent() {
  const { loggedUser } = useSelector(state => state.user)
  const { EURToUSD, GBPToUSD } = useSelector(state => state.packages)

  const [warehouse, setWarehouse] = useState(loggedUser.permissions['Admin'] ? '' : loggedUser.UserAttributes['custom:warehouse'])
  const [shippingPackages, setShippingPackages] = useState([])
  const [packagesToDisplay, setPackagesToDisplay] = useState([])
  const [filterBy, setFilterBy] = useState({})
  // const [sortByReceiptDirection, setSortByReceiptDirection] = useState(0)
  const [sortByLocation, setSortByLocation] = useState(0)

  const [totalWeight, setTotalWeight] = useState(0)
  const [readyToShipWeight, setReadyToShipWeight] = useState(0)
  const [pToShip, setpToShip] = useState([])
  const [showConfirmModal, setShowConfirmModal] = useState(false)
  const [isLoadingRows, setIsLoadingRows] = useState(false)
  const [showShipAllModal, setshowShipAllModal] = useState(false)
  const [totalPtoShip, setTotalPtoShip] = useState(0)
  const [nextPageTkn, setNextPageTkn] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [searchState, updateSearchState] = useState('costumer_firstName')
  const [searchboxState, updateSearchBoxState] = useState('')

  useEffect(() => {
    if (window.location.href.includes('office')) {
      document.getElementById('enable-toolbar').style.display = 'none'
    }

    if (loggedUser.Username) {
      getDataOf()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    getDataOf()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [warehouse])

  const getNextPage = async () => {
    setIsLoadingRows(true)
    try {
      await getDataOf(nextPageTkn)
    } catch (err) {
      console.log(err)
    }
    setIsLoadingRows(false)
  }

  const getDataOf = async pageToken => {
    try {
      setIsLoading(true)
      let filters = {}
      if (warehouse) {
        filters = {
          isPaid: true,
          isShipped: false,
          warehouse: warehouse,
          nextPage: pageToken,
        }
      } else {
        filters = {
          isPaid: true,
          isShipped: false,
          nextPage: pageToken,
        }
      }

      if (pageToken) {
        filters.nextPage = pageToken
      }

      const data = await getAllPackages(filters)
      let packages = data.items
      if (nextPageTkn && shippingPackages.length > 0) {
        packages = [...shippingPackages, ...packages]
      }

      setNextPageTkn(data.nextPage)
      if (packages) {
        //packages = packages.filter((p) => p.buyingReciptKey)
        const allTotalWeight = packages.reduce((accumulator, item) => accumulator + item.weight, 0)
        const readyForShipWeight = packages
          .filter(p => p.price)
          .reduce((acc, p) => {
            return (acc += p.weight)
          }, 0)

        setReadyToShipWeight(readyForShipWeight)
        setTotalWeight(allTotalWeight)
        packages = packages.filter(p => !p.isReturned)
        packages = sortPackagesDataByDatePaid(packages)
        console.log('getDataOf -> packages:', packages)
      }
      setShippingPackages(packages)
      setPackagesToDisplay(packages)
    } catch (error) {
      throw error
    } finally {
      setIsLoading(false)
    }
  }

  // const handleReceiptCheck = async (ev, itemId, currReceiptCheck) => {
  //   // console.log('handleReceiptCheck', ev, itemId, currReceiptCheck)

  //   try {
  //     await updatePackage(itemId, {
  //       receiptCheck: !currReceiptCheck,
  //     })

  //     const newshippingPackagesState = [...shippingPackages]
  //     const idx = newshippingPackagesState.findIndex(item => item.id == itemId)
  //     newshippingPackagesState[idx].receiptCheck = !currReceiptCheck
  //     setShippingPackages(newshippingPackagesState)
  //     // if (!d.data) {
  //     //   throw new Error("Something went wrong with updating the package");
  //     // }
  //   } catch (error) {
  //     console.log(error)
  //     alert(`Error! ${error.response.data.message}`)
  //   }
  // }

  const handleShipAll = async () => {
    setShowConfirmModal(false)
    setshowShipAllModal(true)
    xltResponds = []
    const confirmedReceiptP = shippingPackages.filter(p => p.price)
    setTotalPtoShip(confirmedReceiptP.length)
    let totalWeight = 0
    const newArr = []
    for (let i = 0; i < confirmedReceiptP.length; i++) {
      console.log(confirmedReceiptP[i])
      totalWeight += confirmedReceiptP[i].weight

      newArr.push(confirmedReceiptP[i])
      setpToShip(newArr)

      if (totalWeight > 40) break
    }
    console.log('pToShip', pToShip)
    getDataOf()

    setShowConfirmModal(false)
  }

  const getLinkUrlForItem = async item => {
    const url = getFullUrl(item.buyingReciptKey)
    window.open(url, '_blank')
  }

  const onChangeOfSelectOpt = async () => {
    const warehouse = loggedUser.UserAttributes['custom:warehouse']

    const filters = {
      key: searchState,
      value: searchboxState.trim(),
    }

    let staticFilters = {}
    if (warehouse) {
      staticFilters = {
        isPaid: true,
        isShipped: false,
        warehouse: warehouse,
      }
    } else {
      staticFilters = {
        isPaid: true,
        isShipped: false,
      }
    }

    try {
      const package_data = await getPackagesByIndex(filters, staticFilters)

      setIsLoadingRows(true)
      setShippingPackages(package_data)
    } catch (error) {
      console.log('onChangeOfSelectOpt - error:', error)
      alert(`Error! ${error.response.data?.msg}`)
    }
  }

  const toggleFlammableFilter = () => {
    const updatedState = { ...filterBy, isFlammable: true }
    if (filterBy.isFlammable) delete updatedState.isFlammable
    setFilterBy(updatedState)
  }

  const togglePriceFilter = () => {
    const updatedState = { ...filterBy, price: 0 }
    if (filterBy.price === 0) delete updatedState.price
    setFilterBy(updatedState)
  }

  // const toggleFalseReceiptFilter = () => {
  //   const updatedState = { ...filterBy, receiptCheck: false, buyingReciptKey: '' }
  //   if (filterBy.receiptCheck === false && filterBy.buyingReciptKey === '') {
  //     delete updatedState.receiptCheck
  //     delete updatedState.buyingReciptKey
  //   }
  //   setFilterBy(updatedState)
  // }

  // const toggleReadyForShipping = () => {
  //   const updatedState = { ...filterBy, receiptCheck: true }
  //   if (filterBy.receiptCheck === true) delete updatedState.receiptCheck
  //   delete updatedState.buyingReciptKey
  //   setFilterBy(updatedState)
  // }

  useEffect(() => {
    let filteredPackages = [...shippingPackages]
    for (let [key, value] of Object.entries(filterBy)) {
      filteredPackages = filteredPackages.filter(pkg => pkg[key] === value)
    }

    const allTotalWeight = filteredPackages.reduce((accumulator, item) => accumulator + item.weight, 0)
    const readyForShipWeight = filteredPackages
      .filter(p => p.price)
      .reduce((acc, p) => {
        return (acc += p.weight)
      }, 0)

    setReadyToShipWeight(readyForShipWeight)
    setTotalWeight(allTotalWeight)

    // if (sortByReceiptDirection) {
    //   if (sortByReceiptDirection === 1)
    //     filteredPackages = filteredPackages.sort((p1, p2) => (p1.receiptCheck ?? 0) - (p2.receiptCheck ?? 0))
    //   if (sortByReceiptDirection === -1)
    //     filteredPackages = filteredPackages.sort((p1, p2) => (p2.receiptCheck ?? 0) - (p1.receiptCheck ?? 0))
    // }

    if (sortByLocation) {
      if (sortByLocation === 1) filteredPackages = filteredPackages.sort((p1, p2) => (p1.location ?? 0) - (p2.receiptCheck ?? 0))
      if (sortByLocation === -1) filteredPackages = filteredPackages.sort((p1, p2) => (p2.location ?? 0) - (p1.receiptCheck ?? 0))
    }

    setPackagesToDisplay(filteredPackages)
  }, [shippingPackages, filterBy, sortByLocation])

  // const receiptSortIcon = () => {
  //   if (sortByReceiptDirection === -1) return '▲'
  //   if (sortByReceiptDirection === 1) return '▼'
  //   return '▼▲'
  // }

  const locationSortIcon = () => {
    if (sortByLocation === -1) return '▲'
    if (sortByLocation === 1) return '▼'
    return '▼▲'
  }

  const copyToClipboard = str => {
    navigator.clipboard.writeText(str)
  }

  const updatePackagesList = id => {
    setPackagesToDisplay(packagesToDisplay.filter(p => p.id !== id))
  }

  return (
    <div style={{ marginTop: '120px', padding: '0 60px' }}>
      {(loggedUser.permissions['Admin'] || loggedUser.permissions['Agent'] || loggedUser.permissions['SeniorAgent']) && (
        <OfficeCountryNavBar warehouse={warehouse} setWarehouse={setWarehouse} />
      )}
      <Row>
        <Col
          style={{
            marginLeft: 'auto',
            marginRight: 'auto',
            textAlign: 'center',
          }}
        >
          <h1> Ship</h1>
        </Col>
      </Row>
      {/* <Row style={{ marginTop: "20px", marginBottom: "20px" }}>
        <Col
          style={{
            marginLeft: "auto",
            marginRight: "auto",
            textAlign: "center",
          }}
        >
          <Button
            variant="success"
            onClick={() => {
              setshowConfirmModal(true);
            }}
            disabled
          >
            Prepare for shipment
          </Button>
        </Col>
      </Row> */}
      <div style={{ fontSize: 'large' }}> Ready for shipment total weight : {Math.round(readyToShipWeight)} KG</div>
      <div style={{ fontSize: 'large' }}> Total weight: {Math.round(totalWeight)} KG</div>

      <Table className='ship-search-table' style={{ width: '100%' }}>
        <thead>
          <tr>
            <td>search By</td>
            <td>
              <Form.Control
                as='select'
                onChange={e => {
                  console.log(e.target.value)
                  updateSearchState(e.target.value)
                }}
              >
                <option value='costumer_firstName'>first name</option>
                <option value='costumer_LastName'>family name</option>
                <option value='costumer_Email'>email</option>
                <option value='trackingNumberToIsrael'>xlt</option>
              </Form.Control>
            </td>
            <td>
              <Form.Control
                onChange={e => {
                  updateSearchBoxState(e.target.value)
                  if (searchState === 'phone_number') {
                    updateSearchBoxState('+972' + e.target.value)
                  } else if (searchState !== 'phone_number') {
                    updateSearchBoxState(e.target.value)
                  }
                }}
                size='sm'
                onKeyPress={e => (e.key === 'Enter' ? onChangeOfSelectOpt() : '')}
              ></Form.Control>
            </td>
            <td>
              <Button onClick={() => onChangeOfSelectOpt()}> Search </Button>
              <Button
                variant='info'
                onClick={() => {
                  getDataOf()
                }}
              >
                Show all
              </Button>
            </td>
          </tr>
        </thead>
      </Table>
      <div className='office-ship-filter-container'>
        <div className='office-ship-filter-title'>Filter:</div>
        <button
          className='office-ship-filter-button'
          style={filterBy.isFlammable ? { fontWeight: 'bold', backgroundColor: '#CCC' } : {}}
          onClick={toggleFlammableFilter}
        >
          <img src={flammableIcon} height='24px' />
        </button>
        <button
          className='office-ship-filter-button'
          style={filterBy.price === 0 ? { fontWeight: 'bold', backgroundColor: '#CCC' } : {}}
          onClick={togglePriceFilter}
        >
          Price: 0
        </button>
        {/* <button
          className="office-ship-filter-button"
          style={filterBy.receiptCheck === false && filterBy.buyingReciptKey === '' ? { fontWeight: 'bold', backgroundColor: '#CCC' } : {}}
          onClick={toggleFalseReceiptFilter}
        >
          False Receipt
        </button> */}
        {/* <button
          className="office-ship-filter-button"
          style={filterBy.receiptCheck === true ? { fontWeight: 'bold', backgroundColor: '#CCC', color: 'green' } : { color: 'green' }}
          onClick={toggleReadyForShipping}
        >
          Ready-For-Shipping
        </button> */}
      </div>

      <InfiniteScroll
        loadMore={() => {
          getNextPage(nextPageTkn)
        }}
        threshold={250}
        hasMore={nextPageTkn && !isLoadingRows}
      >
        <Table>
          <thead style={{ backgroundColor: '#fcde00', color: 'white' }}>
            <tr>
              <th> # </th>
              <th> XLT </th>
              <th>Brand </th>
              <th style={{ width: '130px' }}> Date Paid </th>
              <th style={{ width: '130px' }}> Date Arrived </th>
              <th> Costumer </th>
              <th> Costumer Email</th>
              <th>Weight</th>
              <th>Flammable?</th>
              <th>Products</th>
              <th>Value $/€ </th>
              <th>Value USD</th>
              <th>Warehouse</th>

              <th onClick={() => setSortByLocation(prevSort => (prevSort === -1 ? 1 : -1))} style={{ cursor: 'pointer' }}>
                Location {locationSortIcon()}
              </th>
              {/* <th onClick={() => setSortByReceiptDirection((prevSort) => (prevSort === -1 ? 1 : -1))} style={{ cursor: 'pointer' }}>
                Receipt {receiptSortIcon()}
              </th> */}
              <th style={{ textAlign: 'center' }}>Check Receipt</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {packagesToDisplay.length > 0 ? (
              packagesToDisplay.map((item, idx) => {
                return (
                  <tr key={idx} style={{ color: !item.price ? 'red' : '' }}>
                    <td>{idx + 1}</td>
                    <OverlayTrigger
                      placement='bottom'
                      overlay={
                        <Tooltip>
                          <span>Click to copy</span>
                        </Tooltip>
                      }
                    >
                      <td
                        onClick={() => {
                          copyToClipboard(item.trackingNumberToIsrael)
                        }}
                      >
                        {item.trackingNumberToIsrael}
                      </td>
                    </OverlayTrigger>

                    <td>{item.brand}</td>
                    <td>{item.datePayed}</td>
                    <td>{item.dateArrived}</td>
                    <td>{item.costumer_firstName + ' ' + item.costumer_LastName}</td>

                    <td>{item.costumer_Email}</td>
                    <td>{Math.round(item.weight * 100) / 100}KG</td>
                    <td style={{ textAlign: 'center' }}>
                      {item.isFlammable ? (
                        <div>
                          <img src={flammableIcon} height='30px' />
                        </div>
                      ) : (
                        ''
                      )}
                    </td>
                    <OverlayTrigger
                      placement='top'
                      overlay={
                        <Tooltip>
                          {item?.contents?.map((c, i) => {
                            return (
                              <span key={i}>
                                {i > 0 && ', '}
                                {c.productCategory} X {c.quantity}
                              </span>
                            )
                          })}
                        </Tooltip>
                      }
                    >
                      <td style={{ textAlign: 'center' }}>{item.contents?.reduce((t, v) => t + parseInt(v.quantity), 0) || '-'}</td>
                    </OverlayTrigger>
                    <td>
                      <span
                        style={
                          item.price > 9999
                            ? {
                                backgroundColor: '#ffc107',
                              }
                            : {}
                        }
                      >
                        {item.price}
                      </span>
                    </td>
                    <td>{item.valueInUSD}</td>

                    <td>{item.warehouse}</td>
                    <td>{item.warehouseLocation}</td>
                    {/* <td>
                      {item.receiptCheck === false && item.buyingReciptKey === '' ? ( // false receipt package
                        <div className="receipt-td">
                          <img src={noEntryIcon} height="30px" />
                        </div>
                      ) : (
                        // not false receipt package
                        <div
                          className="receipt-td"
                          onClick={(ev) =>
                            (loggedUser.permissions['Admin'] || loggedUser.permissions['OfficeManager']) &&
                            handleReceiptCheck(ev, item.id, item.receiptCheck)
                          }
                        >
                          {item.receiptCheck ? (
                            <div>
                              <img src={vIcon} height="30px" />
                            </div>
                          ) : (
                            <div>
                              <img src={xIcon} height="30px" />
                            </div>
                          )}
                        </div>
                      )}
                    </td> */}
                    <td>
                      <Button
                        variant='link'
                        onClick={() => {
                          getLinkUrlForItem(item)
                        }}
                        style={{ width: '130px' }}
                      >
                        Check Receipt
                      </Button>
                    </td>
                    <td>
                      <ModalForShipping
                        updatePackagesList={() => updatePackagesList(item.id)}
                        item={item}
                        EURToUSD={EURToUSD}
                        GBPToUSD={GBPToUSD}
                      />
                    </td>
                  </tr>
                )
              })
            ) : (
              <tr>
                <td colSpan='20' style={{ textAlign: 'center', marginTop: '15px' }}>
                  {isLoading ? <Spinner animation='border' variant='primary'></Spinner> : 'No packages to ship'}
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </InfiniteScroll>

      <br />
      <div style={{ fontSize: 'large' }}> Ready for shipment total weight: {Math.round(readyToShipWeight)} KG</div>
      <div style={{ fontSize: 'large' }}> Total weight: {Math.round(totalWeight)} KG</div>
      <br />
      <br />

      <Modal show={showConfirmModal} onHide={() => setShowConfirmModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Prepare for shipment</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ textAlign: 'center' }}>
          {/* {isLoading ? (
            <div className="spinner-cont">
              <Spinner animation="border" variant="primary"></Spinner>
            </div>
          ) : (
            <span>Are you sure?</span>
          )} */}
          <span>Are you sure?</span>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => setShowConfirmModal(false)}>No</Button>
          <Button variant='success' onClick={() => handleShipAll()}>
            Yes!
          </Button>
        </Modal.Footer>
      </Modal>

      {showShipAllModal && (
        <ShipAllModal
          setshowShipAllModal={() => setshowShipAllModal()}
          showShipAllModal={showShipAllModal}
          pToShip={pToShip}
          totalPtoShip={totalPtoShip}
          EURToUSD={EURToUSD}
          GBPToUSD={GBPToUSD}
        ></ShipAllModal>
      )}

      <img
        src={scrollUpIcon}
        className='scroll-up-btn'
        onClick={() => {
          window.scrollTo(0, 0)
        }}
      />
    </div>
  )
}

function ModalForShipping(props) {
  const [show, setShow] = useState(false)
  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)
  const { item, EURToUSD, GBPToUSD, updatePackagesList } = props

  const ModalForShippingforceUpdateFunction = () => {
    handleClose()
    updatePackagesList()
  }

  return (
    <div>
      <Button block variant='primary' onClick={handleShow} style={{ width: '150px' }}>
        Ship
      </Button>

      <Modal style={{ textAlign: 'left' }} size='xl' show={show} onHide={handleClose}>
        <Modal.Header closeButton>Confirm receipt and ship package</Modal.Header>
        <Modal.Body>
          <FormComponentForShip
            forceUpdate={ModalForShippingforceUpdateFunction}
            item={item}
            EURToUSD={EURToUSD}
            GBPToUSD={GBPToUSD}
            handleClose={handleClose}
          />
        </Modal.Body>
      </Modal>
    </div>
  )
}

let xltResponds = []

function FormComponentForShip(props) {
  const { forceUpdate, item, EURToUSD, GBPToUSD } = props
  // const [isConfirmClicked, setisConfirmClicked] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const getLinkUrlForItem = async () => {
    // const url = `${S3_FILES}/${item.buyingReciptKey}`;
    const url = getFullUrl(item.buyingReciptKey)
    window.open(url, '_blank')
  }

  // const handleFalseReceipt = async (itemId, emailAddress) => {
  //   //delete recipet from DB
  //   try {
  //     await updatePackage(itemId, {
  //       buyingReciptKey: null,
  //       receiptCheck: false,
  //       falseReceiptDate: new Date().toISOString().split('T')[0],
  //       reqType: 'InvalidReceipt',
  //       emailTemplate: 'InvalidReceipt',
  //       costumer_Email: emailAddress,
  //     })

  //     forceUpdate()
  //   } catch (error) {
  //     console.log(error)
  //     alert(`Error! ${error.response.data.message}`)
  //   }
  // }

  const submitShipS = async () => {
    if (item.valueInUSD >= 250) {
      const confirmMsg = 'The PRICE submitted is HIGH.\nAre you sure you want to continue?'
      const isConfirm = window.confirm(confirmMsg)
      if (!isConfirm) return
    }

    try {
      setIsLoading(true)
      await packageShipping(item)
      forceUpdate()
    } catch (error) {
      console.log('submitShipS - error', error)
      if (error.response.data?.error.Errors?.length > 0) {
        alert('Error shipping package:\n' + error.response.data.msg + '\n' + error.response.data.error.Errors[0].ErrorMessage)
      } else alert('Error shipping package:\n' + error.response.data.msg + '\n' + error.response.data.error)
    } finally {
      setIsLoading(false)
    }
  }

  const changePrice = async ev => {
    let htmlText = ev.target.parentElement.innerText
    let idx = htmlText.indexOf('S') > 0 ? htmlText.indexOf('S') : htmlText.indexOf(':')
    let price = htmlText.substring(0, idx)

    if (!isNaN(price)) {
      try {
        await updatePackage(item.id, {
          price: Number(price),
          warehouse: item.warehouse,
        })

        // if (!d.data) {
        //   throw new Error("Something went wrong with updating the package");
        // }

        ev.target.innerText = ':)'
        // forceUpdate();
      } catch (error) {
        console.log(error)
        alert(`Error! ${error.response.data.message}`)
      }
    } else {
      alert('Please insert numbers only!')
    }
  }

  const copyToClipboard = str => {
    navigator.clipboard.writeText(str)
  }

  return (
    <div>
      <Table>
        <thead style={{ backgroundColor: 'lightgrey' }}>
          <tr>
            <td> ID</td>
            <td style={{ textAlign: 'center' }}> Value $</td>
            <td style={{ textAlign: 'center' }}> Value $/€/₺</td>
            <td> Content</td>
            <td> </td>
            <td> </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <OverlayTrigger
              placement='bottom'
              overlay={
                <Tooltip>
                  <span>Click to copy</span>
                </Tooltip>
              }
            >
              <td
                onClick={() => {
                  copyToClipboard(item.id)
                }}
              >
                {item.id}
              </td>
            </OverlayTrigger>

            <td style={{ textAlign: 'center' }}>{item.valueInUSD ?? getPrice(item, EURToUSD, GBPToUSD)}</td>
            <td style={{ textAlign: 'center' }}>
              <div contentEditable suppressContentEditableWarning={true}>
                {item.price}
              </div>
              <button onClick={ev => changePrice(ev)}>Save</button>
            </td>

            <td>
              {item?.contents?.map((c, i) => {
                return (
                  <span key={i}>
                    {i > 0 && ', '}
                    {c.productCategory} X {c.quantity}
                  </span>
                )
              })}
            </td>
            <td>
              <Button variant='link' onClick={getLinkUrlForItem}>
                Check Receipt
              </Button>
            </td>
          </tr>
          <tr>
            <td colSpan='4'>
              <Button
                variant='danger'
                onClick={submitShipS}
                disabled={!item.price || item.buyingReciptKey === '' || isLoading}
                style={{ width: 'unset' }}
              >
                {isLoading ? <Spinner animation='border' size='sm' /> : 'Confirm and Ship'}
              </Button>{' '}
            </td>{' '}
            <td style={{ textAlign: 'right' }}>
              {/* <Button
                variant="outline-danger"
                onClick={() => handleFalseReceipt(item.id, item.costumer_Email)}
                style={{ width: '130px' }}
                disabled={loggedUser.permissions['Worker'] || loggedUser.permissions['OfficeManager']}
              >
                False Receipt
              </Button> */}
            </td>
          </tr>
        </tbody>
      </Table>
    </div>
  )
}

function ShipAllModal(props) {
  const { setshowShipAllModal, showShipAllModal, EURToUSD, GBPToUSD } = props
  const [packages, setPackages] = useState([])

  console.log('🚀 - ShipAllModal - props.pToShip', props.pToShip)

  const postman = async pId => {
    console.log('postman', pId)
    const p = packages.find(p => p.id === pId)
    const receipt_url = getFullUrl(p.buyingReciptKey)
    const str = `{
        "barcode": "${p.trackingNumberToIsrael}",
        "orderID": "${p.id}",
        "invoiceID": "${p.id}",
        "receiptURL":"${receipt_url}",
        "sender":
        {
          "name": "SHIPTANBUL",
          "addrLine1": "ferhatpasa mah. maresal fevzi cakmak",
          "city": "Istanbul",
          "country": "TR",
          "contactName": "Shiptanbul Office",
          "phoneNumber": "972525227852"
        },
        "receiver":
        {
          "name": "${p.costumer_firstName} ${p.costumer_LastName}",
          "addrLine1": "${p.shippingAdress_adress} ",
          "addrLine2": "${p.shippingAdress_apartmentNumber}",
          "city": "${p.shippingAdress_city}",
          "country": "IL",
          "zip": "${p.shippingAdress_postalCode}",
          "contactName": "${p.costumer_firstName} ${p.costumer_LastName}",
          "phoneNumber":"${0 + p.unit}"
        },
        "items":
        {
          "description": "${getContents()}",
          "declaredValue": "${getPrice(p, EURToUSD, GBPToUSD)}",
          "currency": "USD",
          "weight":"${p.weight}"
        },
        "weight": "${p.weight}",
        "volumetricWeight": "${(p.height * p.length * p.width) / 5000}",
        "serviceLine":"${p.shippingMethod}"
      }`

    function getContents() {
      let str = ''
      p.contents.forEach(obj => (str += `${obj.quantity} X ${obj.productCategory}`))
      return str
    }

    try {
      navigator.clipboard.writeText(str)
      document.getElementById(`postman-btn ${p.id}`).innerText = ':)'
    } catch (err) {
      console.log(err)
    }

    console.log(str)
  }

  const regxPattern = /^XLT/

  useEffect(() => {
    setPackages(props.pToShip)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Modal size='xl' show={showShipAllModal} onHide={() => setshowShipAllModal(false)} aria-labelledby='example-modal-sizes-title-lg'>
      <Modal.Header closeButton>
        <Modal.Title id='example-modal-sizes-title-lg'>Sending packages to Exelot</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* <h4> Total packages to send: {totalPtoShip}</h4> */}
        <Table style={{ textAlign: 'left' }}>
          <tbody>
            {packages.length > 0 &&
              packages.map((p, idx) => (
                <tr key={idx}>
                  <td> {idx + 1} </td>
                  <td> {p.id} </td>
                  <td className={regxPattern.test(xltResponds[idx]) ? '' : 'red-color'}>{xltResponds[idx]}</td>
                  <td>
                    <Button id={`postman-btn ${p.id}`} variant='warning' onClick={() => postman(p.id)}>
                      Postman
                    </Button>
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>
      </Modal.Body>
    </Modal>
  )
}
